import React, { Component } from "react"
import { connect } from "react-redux"
import { PATH } from "../../modules/constants"
import history from "../../services/history"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
import Button from "@mui/material/Button"
import { withStyles } from "@mui/styles"

const styles = () => ({
  text: {
    whiteSpace: "pre-wrap"
  }
})

const onLoginButton = () => history.push(`/${PATH.LOGIN}`)
const onRegisterButton = () => history.push(`/${PATH.REGISTER}`)

class WhyRegisterModal extends Component {

  render() {
    const { onClose, open, the350club } = this.props
    return (
      <React.Fragment>

        <Dialog
          disableRestoreFocus={true}
          open={Boolean(open)}
          onClose={onClose}
          maxWidth="sm" fullWidth>

          <DialogTitle>This feature is available only when you are logged in to Numerable</DialogTitle>

          <DialogContent>
            <DialogContentText>When you are registered and logged in you can save companies and people to your favourites, to easily return to them later</DialogContentText>

            {/*!the350club && <DialogContentText>You can <a href="/register">register now</a> for a FREE 14 day trial of our Standard subscription, with access to past directors, timeline view, connections, PDF snapshot, export CSV, analysis and external links.</DialogContentText>*/}

          </DialogContent>

          <DialogActions>
            <Button onClick={onClose} color="primary">
              Cancel
            </Button>

            <Button variant="contained" onClick={onLoginButton} color="primary">
              Login
            </Button>

            <Button variant="contained" onClick={onRegisterButton} color="primary">
              Register
            </Button>

          </DialogActions>

        </Dialog>
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ common }) => {
  return {
    the350club: common.the350club,
  }
}

// @ts-ignore
export default connect(mapStateToProps)(withStyles(styles)(WhyRegisterModal))

